import CancellationReasons from './CancellationReasons'

export default CancellationReasons
